import useApi from "@/services/useApi";

const { api } = useApi();
export default function usePaymentTariffs(paymentSystem) {
    const domain = window.location.host === 'e-chat.tech' ? 'https://e-chat.tech/profile' : 'https://dev.e-chat.tech/profile'
    // const domain = 'https://e-chat.tech/profile'

    // const auth = 'Bearer ' + process.env.MIX_APP_AUTH_TOKEN;
    const auth = 'Bearer ' + localStorage.getItem('token');
    // console.log(paymentSystem)
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': auth
    }

    const getLinkToBill = async (tariffData) => {
        const url = domain + '/api/payments/' + paymentSystem

        const response = await api.post(url, tariffData, { headers });
        return response.data;
    };

    return {
        getLinkToBill,
    };
}
